"use client";

import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";
import {
	AppBar,
	Box,
	Divider,
	Image,
	Toolbar,
	Typography,
	useMediaQuery,
	useTheme,
} from "@/components/controls/base-controls";
import LocaleSelect from "@/components/locale/locale-select";
import {
	HEADER_HEIGHT_FULL,
	HEADER_HEIGHT_MOBILE,
	WEBPAGE_CORE_CONTAINER,
} from "@/core/constants/webpages";

const NoAuthHeader = () => {
	const t = useTranslations();

	const theme = useTheme();
	// Returns true if screen width is 'sm' (default 600px) or smaller
	const isMobileQuery = useMediaQuery(theme.breakpoints.down("sm"));

	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		setIsMobile(isMobileQuery);
	}, [isMobileQuery]);

	return (
		<AppBar
			elevation={1}
			sx={{
				position: isMobile ? "relative" : "fixed",
				backgroundColor: "var(--mui-palette-header-no-auth-bg)",
				top: 0,
				left: 0,
				right: 0,
				zIndex: 10,
				px: 0,
				overflow: "hidden",
			}}
		>
			<Toolbar
				disableGutters
				sx={{
					display: "flex",
					flexDirection: "row",
					height: { xs: HEADER_HEIGHT_MOBILE, md: HEADER_HEIGHT_FULL },
					justifyContent: "space-between",
					alignItems: "center",
					margin: "0 auto",
					paddingLeft: "1em",
					paddingRight: ".5em",
					width: WEBPAGE_CORE_CONTAINER,
					maxWidth: "100%",
				}}
			>
				<Box
					sx={{
						display: "flex",
						alignItems: "center",
						gap: { xs: 1, md: 2 },
					}}
				>
					<Image
						src="/images/logo_ld.png"
						alt="Navairra Logo"
						loading="eager"
						width={isMobileQuery ? 44 : 66}
						height={isMobileQuery ? 31 : 47}
					/>
					<Typography
						variant="companyName"
						sx={{
							color: "var(--mui-palette-darkest)",
						}}
					>
						{t("company.name")}
					</Typography>

					<Divider
						orientation="vertical"
						flexItem
						sx={{
							borderColor: "var(--mui-palette-dull)",
							height: "2em",
							borderRightWidth: "2px",
							my: "auto",
						}}
					/>

					<Typography
						variant="tagLine"
						sx={{
							color: "var(--mui-palette-darkest)",
							mt: { xs: "4px", md: ".4em" },
						}}
					>
						{t("company.tagLine1")}
					</Typography>
				</Box>

				<Box
					sx={{
						mt: { xs: ".6em", md: ".5em" },
					}}
				>
					<LocaleSelect fontColor="var(--mui-palette-darkest)" />
				</Box>
			</Toolbar>
		</AppBar>
	);
};

export default NoAuthHeader;
